require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-instructor-picks-what-s-coming-in-2015.json") })
        }
      }, "path---blog-instructor-picks-what-s-coming-in-2015");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-instructor-picks-what-s-coming-in-2015!./.cache/json/blog-instructor-picks-what-s-coming-in-2015.json
// module id = 888
// module chunks = 231608221292675